export default {
    // should move to v4/modules/preference
    setPreferences(state, payload) {

        const newPreferences = payload.preferences;
        const oldPreferences = state.preferences || [];

        oldPreferences.forEach(old_pref => {
            try {
                let new_pref = newPreferences.find(new_pref => new_pref.id === old_pref.id)
                // handle geo_permission
                if (old_pref.name === 'geo_permission') {

                    if (new_pref && new_pref.responses[0].id === old_pref.responses[0].id) {
                        new_pref.responses[0].selected = old_pref.responses[0].selected
                        new_pref.responses[0].value = old_pref.responses[0].value
                    }
                }

                // handle single select
                else if (old_pref.type === 'select' && old_pref.input === 'multiselect') {
                    let old_response = old_pref.responses.find(old_res => old_res.selected)

                    if (new_pref && old_response) {
                        let new_response = new_pref.responses.find(new_res => new_res.id === old_response.id)
                        if (new_response) {
                            new_response.selected = old_response.selected
                        }
                    }
                }
                
                // handle text input
                else if (old_pref.input === 'textinput') {
                    let value_ok = false
                    let entered_value = old_pref.responses[0].value
                    
                    if (!new_pref || (new_pref.responses[0].id !== old_pref.responses[0].id) || !entered_value) {
                        // dont pass if no matching new pref or panel response ids different or no entered value
                    }
                    else if (new_pref.options.inputValidation) {
                        let new_reg = new RegExp(new_pref.options.inputValidation)
                        if (new_reg.test(entered_value)) {
                            value_ok = true
                        }
                    }
                    else value_ok = true // value entered AND no input validation to test against
                    
                    if (value_ok) {
                        new_pref.responses[0].selected = old_pref.responses[0].selected
                        new_pref.responses[0].value = old_pref.responses[0].value
                        new_pref.responses[0].unknown = old_pref.responses[0].unknown
                    }
                }
            }
            catch (e) {}

        })

        state.preferences = newPreferences;
        state.hashes.preferences = payload.hash
    },

    // should move to v4/modules/collect
    setRecordsInQueue(state, payload) {
        state.recordsInQueue = payload
    }

}
